// useAxiosSetup.js
import axios from "axios";

const useAxiosSetup = () => {
  // 인터셉터 ID를 저장
  let interceptorId = null;

  // 재시도 횟수 관리
  let retryCount = 0;

  const resetRetryCount = () => {
    retryCount = 0;
  };

  const incrementRetryCount = () => {
    retryCount++;
  };

  // 기존 인터셉터 제거
  const removeInterceptors = () => {
    if (interceptorId !== null) {
      axios.interceptors.response.eject(interceptorId);
      interceptorId = null;
    }
  };

  // 인터셉터 등록 전 기존 인터셉터 제거
  removeInterceptors();

  // 요청 시 토큰 설정을 위한 기본 설정
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

  // 응답 인터셉터만 설정 (토큰 갱신 로직)
  interceptorId = axios.interceptors.response.use(
    (response) => response, // 정상 응답 처리
    async (error) => {
      // 서버 응답이 있는 경우 에러 메시지 처리
      if (error.response) {
        const responseData = error.response.data;
        if (responseData && responseData.message) {
          console.error(`서버에서의 오류 메시지: ${responseData.message}`);
        }

        // 401 에러(인증 실패)일 때만 토큰 갱신 시도
        if (error.response.status === 401) {
          // 재시도 횟수 체크
          if (retryCount >= 3) {
            // 최대 시도 횟수 3회
            console.error("토큰 재발급 최대 시도 횟수 초과");
            resetRetryCount(); // 재시도 횟수 초기화
            localStorage.clear();
            window.location.href = "/login";
            return Promise.reject("토큰 재발급 오류");
          }

          incrementRetryCount();

          try {
            // 토큰 재발급 요청
            const response = await axios.post("/api/refresh-token", {}, { withCredentials: true });

            if (response.status === 200) {
              const newAccessToken = response.data;
              localStorage.setItem("token", newAccessToken);

              // 새 토큰으로 원래 요청 재시도
              error.config.headers["Authorization"] = `Bearer ${newAccessToken}`;
              // 재시도 시 무한루프 방지
              error.config._retry = true;
              return axios(error.config);
            }
          } catch (refreshError) {
            console.error("토큰 갱신 실패:", refreshError.message);

            if (refreshError.response) {
              console.error("응답 상태:", refreshError.response.status);
              console.error("응답 데이터:", refreshError.response.data);

              if ([401, 403, 502].includes(refreshError.response.status)) {
                console.log("인증 오류 또는 서버 오류 - 로그아웃 처리");
                localStorage.clear();
                window.location.href = "/login";
              }
            }
            return Promise.reject(refreshError);
          }
        }
      } else {
        // 서버 응답이 없는 경우 (네트워크 오류 등)
        console.error("서버 응답이 없습니다.");
      }

      // 401이 아닌 다른 에러는 그대로 반환
      return Promise.reject(error);
    }
  );

  // 컴포넌트 언마운트 시 인터셉터 제거를 위한 클린업 함수 반환
  return removeInterceptors;
};

export default useAxiosSetup;
